import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'portal-ui-confirm-remove-file',
  standalone: true,
  imports: [],
  template: `<p>Are you sure you want to remove this file? This action cannot be undone.</p>`,
  styles: [':host {display: block}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmRemoveFileComponent {}
